import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import plusIcon from '@iconify-icons/mdi/plus';
import minusIcon from '@iconify-icons/mdi/minus';

const FooterSection = ({onZoomIn, onZoomOut  }) => {

  return (
    <div className="footer-section"  style={{
        background: "rgb(231, 231, 231)",
        borderRadius: "0px 0px 10px 10px",
        height: "21px"
      }}>
      <div className="footer-action-buttons">
            <div className='footer-zoom-InOutText'>
                <button onClick={onZoomOut} className='classZoombutton'>
                    <Icon icon={minusIcon} width="16" height="16" />
                </button>
                <button onClick={onZoomIn} className='classZoombutton'>
                    <Icon icon={plusIcon} width="16" height="16" />
                </button>
            </div>
      </div>
    </div>
  );
};

export default FooterSection;




